import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';

import { AiDialogComponent } from './ai-dialog.component';

@NgModule({
  declarations: [AiDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    ButtonModule,
    InputTextareaModule,
    TooltipModule
  ],
  exports: [AiDialogComponent]
})
export class AiDialogModule {}
